"use strict";

exports.__esModule = true;
exports.TargetPopover = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _TargetPopoverContent = require("./TargetPopoverContent");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var TargetPopover = exports.TargetPopover = function TargetPopover(props) {
  var _onSubmit = props.onSubmit,
    showButton = props.showButton,
    targetValue = props.targetValue,
    propsOnOpen = props.onOpen,
    propsOnClose = props.onClose,
    propsIsOpen = props.isOpen;
  var _useState = (0, _react.useState)(false),
    isOpen = _useState[0],
    setIsOpen = _useState[1];
  var onClick = function onClick(e) {
    e.stopPropagation();
    e.preventDefault();
    if (propsIsOpen && propsOnClose) {
      propsOnClose();
      return;
    } else if (propsOnOpen) {
      propsOnOpen();
      return;
    }
    setIsOpen(function (state) {
      return !state;
    });
  };
  var onClose = function onClose(e) {
    (e == null ? void 0 : e.stopPropagation) && e.stopPropagation();
    (e == null ? void 0 : e.preventDefault) && e.preventDefault();
    if (propsOnClose) {
      propsOnClose();
      return;
    }
    setIsOpen(false);
  };
  return /*#__PURE__*/_react["default"].createElement(_core.Popover, {
    canEscapeKeyClose: true,
    position: _core.PopoverPosition.LEFT,
    captureDismiss: true,
    content: /*#__PURE__*/_react["default"].createElement(_TargetPopoverContent.TargetPopoverContent, {
      target: targetValue,
      onSubmit: function onSubmit(e) {
        _onSubmit(e);
        onClose();
      }
    }),
    isOpen: propsIsOpen || isOpen,
    onClose: onClose
  }, showButton || isOpen || propsIsOpen ? /*#__PURE__*/_react["default"].createElement(_core.Button, {
    "data-testid": "TargetPopover.button.edit",
    minimal: true,
    onClick: onClick,
    icon: _icons.IconNames.SERIES_ADD
  }) : null);
};